import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "count-group",
  "use": "count-group-usage",
  "viewBox": "0 0 18 18",
  "content": "<symbol viewBox=\"0 0 18 18\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"count-group\"><defs><path d=\"M12,12 L12,18 L0,18 L0,6 L6,6 L6,0 L18,0 L18,12 L12,12 Z\" id=\"count-group_a\" /></defs><g fill=\"none\" fill-rule=\"evenodd\"><g transform=\"matrix(1 0 0 -1 0 18)\"><mask id=\"count-group_b\" fill=\"#fff\"><use xlink:href=\"#count-group_a\" /></mask><use fill=\"#FFF\" xlink:href=\"#count-group_a\" /><g mask=\"url(#count-group_b)\" fill=\"#FFF\"><path d=\"M0 0H40V40H0z\" transform=\"translate(-11 -11)\" /></g></g><text font-family=\"TamilMN-Bold, Tamil MN\" font-size=\"14\" font-weight=\"bold\" fill=\"#000\" transform=\"translate(0 -2)\"><tspan x=\"2\" y=\"12\">#</tspan></text></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/app/assets/svg/count-group.svg
// module id = 726
// module chunks = 0